class ActionTypes {
    static ROUTER = 1;
    static REDIRECT  = 2;
  }
  
  export default ActionTypes;
  